import { render, staticRenderFns } from "./FormSuccessB.vue?vue&type=template&id=351890cc&"
import script from "./FormSuccessB.vue?vue&type=script&lang=js&"
export * from "./FormSuccessB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports